/* Auth-gated entry to the backoffice. Email/password sign-in plus a
   password-reset flow. Allow-list (admins/{uid}) is checked after
   sign-in by AuthContext; a signed-in non-admin sees a refusal. */
import { useState } from 'react'
import { useAuth } from './AuthContext.jsx'

export function Login() {
  const { signIn, resetPassword, user, isAdmin, checked } = useAuth()
  const [email, setEmail] = useState('')
  const [pw, setPw] = useState('')
  const [msg, setMsg] = useState(null)
  const [busy, setBusy] = useState(false)

  async function submit(e) {
    e.preventDefault()
    setMsg(null)
    setBusy(true)
    try {
      await signIn(email.trim(), pw)
    } catch (err) {
      setMsg({ kind: 'err', text: friendly(err) })
    } finally {
      setBusy(false)
    }
  }

  async function reset() {
    if (!email.trim()) return setMsg({ kind: 'err', text: 'Enter your email first, then reset.' })
    setMsg(null)
    try {
      await resetPassword(email.trim())
      setMsg({ kind: 'ok', text: 'Reset link sent. Check your email.' })
    } catch (err) {
      setMsg({ kind: 'err', text: friendly(err) })
    }
  }

  // Signed in but not allow-listed — only once the admin check has finished,
  // so the refusal never flashes during the (async) check right after login.
  const refused = user && checked && !isAdmin

  return (
    <div className="login">
      <div className="login-card">
        <div className="lmark">
          Curated<b>H</b>omes
        </div>
        <div className="lsub">BACKOFFICE · IN CONFIDENCE</div>
        {refused ? (
          <div className="login-hint" style={{ color: '#c9a44e' }}>
            This account isn’t authorised for the backoffice.
          </div>
        ) : (
          <form onSubmit={submit}>
            <div className="lfield">
              <label>Email</label>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                autoComplete="username"
              />
            </div>
            <div className="lfield">
              <label>Password</label>
              <input
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                type="password"
                autoComplete="current-password"
                placeholder="••••••••"
              />
            </div>
            <button className="btn-sage" type="submit" disabled={busy}>
              {busy ? 'Entering…' : 'Enter'}
            </button>
          </form>
        )}
        {msg && (
          <div
            className="login-hint"
            style={{ color: msg.kind === 'err' ? '#c9a44e' : 'var(--sage)' }}
          >
            {msg.text}
          </div>
        )}
        {!refused && (
          <button
            className="btn-ghost"
            style={{ width: '100%', marginTop: 12 }}
            type="button"
            onClick={reset}
          >
            Forgot password
          </button>
        )}
      </div>
    </div>
  )
}

function friendly(err) {
  const code = (err && err.code) || ''
  if (
    code.includes('invalid-credential') ||
    code.includes('wrong-password') ||
    code.includes('user-not-found')
  )
    return 'Email or password is incorrect.'
  if (code.includes('too-many-requests')) return 'Too many attempts. Try again later.'
  if (code.includes('invalid-email')) return 'That email address looks invalid.'
  return 'Something went wrong. Please try again.'
}
